import { useState, useContext } from "react";

import { Card } from "@mui/material";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { LanguageContext } from "App";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { createUserWithEmailAndPassword, getAuth } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import UsersApi from "../../../Classes/API/UsersApi";
import CreateUserReq from "../../../Classes/Models/Requests/Users/CreateUserReq";
import Swal from "sweetalert2";
import CountrySelector from "layouts/authentication/sign-up/CountrySelector";
import Select from "react-select";

import { useNavigate } from "react-router-dom";
import "./style.scss";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import firebaseConfig from "FirebaseConfig";
import zIndex from "@mui/material/styles/zIndex";

// Initialize Firebase
const app2 = initializeApp(firebaseConfig, "elagiCreateUser");

const index = () => {
  const navigate = useNavigate();
  const { translations, lang } = useContext(LanguageContext);
  const [Username, SetUsername] = useState("");
  const [Address, SetAddress] = useState("");
  const [Nationality, SetNationality] = useState("");
  const [Number, SetNumber] = useState("");
  const [FoundBy, SetFoundBy] = useState("");
  const [Gender, SetGender] = useState("");
  const [Age, SetAge] = useState(0);

  const [Password, SetPassword] = useState("");
  const [ConfirmPassword, SetConfirmPassword] = useState("");

  const [ErrorText, SetErrorText] = useState("");

  const [Email, SetEmail] = useState("");
  const [NationalId, setNationalId] = useState("");
  const [RelativeNumber, setRelativeNumber] = useState("");
  const [AccreditedPartners, setAccreditedPartners] = useState("");
  const [ChronicDiseases, setChronicDiseases] = useState("");
  const [Sensitivity, setSensitivity] = useState("");
  const [Medications, setMedications] = useState("");

  const auth = getAuth(app2);
  const [user, loading, error] = useAuthState(auth);

  const onSubmit = async () => {
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );

    if (!pattern.test(Email)) {
      Swal.fire({
        title: "error",
        text: translations.PleaseEnterEmail,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (Username.length == 0) {
      Swal.fire({
        title: "error",
        text: translations.PleaseEnterUsername,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (Number.length == 0) {
      Swal.fire({
        title: "error",
        text: translations.PleaseEnterPhonenumber,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (Address.length == 0) {
      Swal.fire({
        title: "error",
        text: translations.PleaseEnterAddress,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (Nationality.length == 0) {
      Swal.fire({
        title: "error",
        text: translations.PleaseEnterNationality,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (Password !== ConfirmPassword) {
      Swal.fire({
        title: "error",
        text: translations.PleaseEnterPassword,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    if (Password.length < 6) {
      Swal.fire({
        title: "error",
        text: translations.Pleaseensurethatthepasswordismorethan6letters,
        icon: "error",
        confirmButtonText: "ok",
      });
      return;
    }

    createUserWithEmailAndPassword(auth, Email, Password)
      .then(async (userCredential) => {
        // Signed in

        let req = new CreateUserReq();
        const user = userCredential.user;

        req.FirebaseId = user.uid;
        req.Number = Number;
        req.Address = Address;
        req.Name = Username;
        req.Gender = Gender;
        req.Age = Age;
        req.FoundBy = FoundBy;
        req.Nationality = Nationality;
        req.UserType = "UnAssigned";
        req.isActivated = false;
        req.isSoftDeleted = false;
        req.isAssessmentTherapist = false;
        req.Email = Email;
        req.NationalId = NationalId;
        req.RelativeNumber = RelativeNumber;
        req.AccreditedPartners = AccreditedPartners;
        req.ChronicDiseases = ChronicDiseases;
        req.Sensitivity = Sensitivity;
        req.Medications = Medications;
        req.TenantId = 2;

        var res = await UsersApi.CreateUser(req);

        if (res.status == "Success") {
          navigate("/Users/Options", {
            state: {
              SearchUser: res.data,
            },
          });
        }
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        SetErrorText(errorMessage);
        console.log(error);
        // ..
      });
  };

  console.log(translations);
  const GenderOptions = [
    { value: "male", label: "male" },
    { value: "female", label: "female" },
  ];
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Card>
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h6" fontWeight="medium">
            {translations.CreateUser}
          </MDTypography>
          <MDButton
            onClick={() => onSubmit()}
            sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
            color="success"
          >
            {translations.CreateUser}
          </MDButton>
        </MDBox>

        <MDBox pt={2} pb={3} px={3}>
          <MDBox
            component="form"
            role="form"
            className={translations.setlang === "ar" ? "rtl-label" : ""}
          >
            <div className="row">
              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => SetEmail(e.target.value)}
                  type="email"
                  label={translations.CreateUserEmail}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => SetUsername(e.target.value)}
                  type="text"
                  label={translations.CreateUserName}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => SetNumber(e.target.value)}
                  type="tel"
                  label={translations.CreateUserPhone}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => SetAddress(e.target.value)}
                  type="text"
                  label={translations.CreateUserAddress}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => SetAge(e.target.value)}
                  type="age"
                  label={translations.CreateUserAge}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => SetFoundBy(e.target.value)}
                  type="text"
                  label={translations.CreateUserFoundby}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => SetPassword(e.target.value)}
                  type="password"
                  label={translations.CreateUserpassword}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => SetConfirmPassword(e.target.value)}
                  type="password"
                  label={translations.CreateUserConfirmPassword}
                  fullWidth
                />
              </div>
              <div className="col-md-4 mt-3" style={{ position: "relative", zIndex: "12" }}>
                <Select
                  styles={
                    translations.setlang === "ar"
                      ? {
                          control: (base) => ({
                            ...base,
                            direction: "rtl",
                          }),
                          placeholder: (base) => ({
                            ...base,
                            textAlign: "right",
                          }),
                          singleValue: (base) => ({
                            ...base,
                            textAlign: "right",
                          }),
                        }
                      : {}
                  }
                  style={{ zIndex: "9999", position: "relative" }}
                  placeholder={translations.CreateUserGender}
                  onChange={(e) => SetGender(e.value)}
                  options={GenderOptions}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setNationalId(e.target.value)}
                  type="text"
                  label={translations.CreateUserNationalID}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setRelativeNumber(e.target.value)}
                  type="text"
                  label={translations.CreateUserRelativeNumber}
                  fullWidth
                />
              </div>
              <div className="col-md-4 mt-3" style={{ position: "relative", zIndex: "10" }}>
                <CountrySelector
                  placeholder={translations.CreateUserNationality}
                  SetNationality={SetNationality}
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  onChange={(e) => setAccreditedPartners(e.target.value)}
                  type="text"
                  label={translations.CreateUserAccreditedPartners}
                  fullWidth
                />
              </div>

              <div className="col-md-8 mt-3">
                <MDInput
                  onChange={(e) => setMedications(e.target.value)}
                  type="text"
                  label={translations.CreateUserDoyouhaveMedicationsconstantly}
                  fullWidth
                />
              </div>

              <div className="col-md-12 mt-3">
                <MDInput
                  onChange={(e) => setSensitivity(e.target.value)}
                  type="text"
                  label={translations.CreateUserDoyouhaveSensitivitytoanything}
                  fullWidth
                />
              </div>

              <div className="col-md-12 mt-3">
                <MDInput
                  onChange={(e) => setChronicDiseases(e.target.value)}
                  type="text"
                  label={translations.CreateUserDoyouhaveChronicDiseases}
                  fullWidth
                />
              </div>

              <div className="col-md-4 mt-3">
                <MDBox mt={4} mb={1}>
                  <MDTypography variant="overline" color={"error"}>
                    {ErrorText}
                  </MDTypography>
                </MDBox>
              </div>
            </div>
          </MDBox>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
};

export default index;
